import React from 'react';
import classnames from 'classnames';

import classes from './ProductBundle.scss';

export const BundleSectionTitle: React.FC<{
    title: React.ReactNode;
    disabled: boolean;
    id?: number | string;
    anchor?: boolean;
}> = (props) => {
    return (
        <h2
            className={classnames({
                [classes.header]: true,
                [classes.headerDisabled]: props.disabled,
            })}
        >
            {props.title}
            {props.anchor && <span className={classes.anchor} id={`artwork-anchor-id-${props.id}`} />}
        </h2>
    );
};
